var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEaCalculatorIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 63 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "ea-calculator-icon_svg__a",
    d: "M0 0h39.66v54.915H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ea-calculator-icon_svg__c",
    d: "M0 60h62.034V0H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.746 22.373c0 12.356-10.017 22.373-22.373 22.373C10.017 44.746 0 34.729 0 22.373 0 10.017 10.017 0 22.373 0c12.356 0 22.373 10.017 22.373 22.373",
    fill: "#F8D7CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.881 6.102H25.424c-1.124 0-2.034.91-2.034 2.034v48.813c0 1.124.91 2.034 2.034 2.034h33.56c1.123 0 2.033-.91 2.033-2.034V14.237L52.88 6.102z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E9EA",
    d: "M52.881 6.102h-1.017v9.152h9.153v-1.017z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.373 5.085)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ea-calculator-icon_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ea-calculator-icon_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M36.61 54.915H3.05A3.054 3.054 0 010 51.865v-3.051h2.034v3.05c0 .562.455 1.017 1.017 1.017h33.56c.56 0 1.016-.455 1.016-1.017V9.574l-7.54-7.54H3.051c-.562 0-1.017.455-1.017 1.017v10.17H0V3.05A3.054 3.054 0 013.05 0h27.458c.271 0 .53.107.72.298l8.135 8.136c.191.19.298.448.298.719v42.711a3.055 3.055 0 01-3.05 3.051",
    fill: "#020303",
    mask: "url(#ea-calculator-icon_svg__b)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M57.967 16.271h-6.102a1.016 1.016 0 01-1.017-1.017V9.153h2.034v5.084h5.085v2.034z",
    fill: "#020303"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "ea-calculator-icon_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ea-calculator-icon_svg__c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    mask: "url(#ea-calculator-icon_svg__d)",
    d: "M9.153 51.864h24.406V21.356H9.153z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E74A10",
    mask: "url(#ea-calculator-icon_svg__d)",
    d: "M9.153 30.508h24.406v-9.152H9.153z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.17 50.847h22.372V22.373H10.17v28.474zm-2.034 2.034h26.44V20.34H8.136v32.542z",
    fill: "#020303",
    mask: "url(#ea-calculator-icon_svg__d)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#020303",
    mask: "url(#ea-calculator-icon_svg__d)",
    d: "M9.153 31.525h24.406v-2.033H9.153zM9.153 38.644h24.406V36.61H9.153zM17.288 45.763H33.56v-2.034H17.29z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#020303",
    mask: "url(#ea-calculator-icon_svg__d)",
    d: "M24.407 51.864h2.034V30.508h-2.034zM16.271 51.864h2.034V30.508h-2.034zM42.203 30.508a2.545 2.545 0 00-2.542 2.543 2.545 2.545 0 002.542 2.542 2.545 2.545 0 002.543-2.542 2.545 2.545 0 00-2.543-2.543m0 7.12a4.582 4.582 0 01-4.576-4.577 4.582 4.582 0 014.576-4.576 4.582 4.582 0 014.577 4.576 4.582 4.582 0 01-4.577 4.576M53.39 39.661a2.545 2.545 0 00-2.542 2.542 2.545 2.545 0 002.542 2.543 2.545 2.545 0 002.543-2.543 2.545 2.545 0 00-2.543-2.542m0 7.119a4.582 4.582 0 01-4.576-4.577 4.582 4.582 0 014.576-4.576 4.582 4.582 0 014.577 4.576 4.582 4.582 0 01-4.577 4.577M40.677 46.78a1.016 1.016 0 01-.765-1.686L54.15 28.822a1.017 1.017 0 011.532 1.338L41.443 46.433c-.201.23-.483.348-.766.348"
  }))));
}
export default SvgEaCalculatorIcon;